import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Container, Navbar } from 'react-bootstrap';
import { Column, Row } from '../../components';
import { ErrorBoundary } from 'react-error-boundary';
import { FallbackComponent } from '../../shared/components/FallbackComponent';
import LookUpSideBar from "./LookUpSideBar";
import LookUpDetails from "./LookUpDetails";
import LookUpDetailModel from '../../Admin/model/LookUpDetailModel';

const LookUpTableMain = () => {
    const { tableId } = useParams<{ tableId: string | undefined }>();
    const [selectedTableId, setSelectedTableId] = useState<string>(null);
    const [reloadSidebar, setReloadSidebar] = useState(false);
    const [showLookupDetailsOnLoad, setShowLookupDetailsOnLoad] = useState<boolean>(false);    
    const { tableName } = useParams<{ tableName: string | undefined }>();
    const [selectedTableName, setSelectedTableName] = useState<string>(null);
    const lookupDetailsData: LookUpDetailModel[] = [];

    useEffect(() => {
        if (tableId) {
            setSelectedTableId(tableId);
            setSelectedTableName(tableName);
            setShowLookupDetailsOnLoad(true);
        }
    }, [tableId]);

    return (
        <>
            <Container fluid className='px-4'>
                <Row className="role-privilege-main">
                    <Column lg={12} md={12}>
                        <ErrorBoundary FallbackComponent={FallbackComponent}>
                            <Row>
                                <Column lg={9}>
                                    <Navbar className="bg-transparent">
                                        <Navbar.Brand>Lookup Table Values</Navbar.Brand>
                                    </Navbar>
                                </Column>
                            </Row>
                            <Card>
                                <Container fluid>
                                    <Row>
                                        <Column lg={12} className='role-details'>
                                            <Row>
                                                <Column lg={3} className='roles-sidebar ps-0'>
                                                    <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                        <div className={`active card shadow-sm`}>
                                                            <LookUpSideBar reload={reloadSidebar} />
                                                        </div>
                                                    </ErrorBoundary>
                                                </Column>

                                                {showLookupDetailsOnLoad &&
                                                    <Column lg={9} className={'screen-privilege'}>
                                                        <Card>
                                                            <ErrorBoundary FallbackComponent={FallbackComponent}>
                                                                <div className='p-0'>
                                                                    <LookUpDetails tableId={selectedTableId} data={lookupDetailsData} tableName={selectedTableName}></LookUpDetails>
                                                                </div>
                                                            </ErrorBoundary>
                                                        </Card>
                                                    </Column>
                                                }
                                            </Row>
                                        </Column>
                                    </Row>
                                </Container>
                            </Card>
                        </ErrorBoundary>
                    </Column>
                </Row>
            </Container>
        </>
    )
}

export default LookUpTableMain;